export const DEFAULT_STALE_DATA_TIMEOUT = 1000 * 60 * 5 // 5 minutes

export type AppConfig = {
  backOfficeDataServiceUrl: string
}
